<p>distributor-detail works!</p>
